import React, { PropTypes } from 'react';
import { RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import ErrorContainer from './ErrorContainer';

let componentId = 1;

class RadioGroup extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.any,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired
    })).isRequired,
    disabled: PropTypes.bool,
    inline: PropTypes.bool.isRequired
  };

  static contextTypes = {
    muiTheme: PropTypes.object
  };

  constructor() {
    super(...arguments);
    this._componentId = 'RadioGroup' + componentId++;
  }

  getStyle() {
    let { inline } = this.props;

    return {
      input: {
        // @todo find it in muiTheme
        marginTop: 14
      },
      radioButtonGroup: inline ? {
        display: 'flex', flexDirection: 'row'
      } : {},
      radioButton: inline ? {display: 'flex'} : {
        marginBottom: 20
      }
    };
  }

  render() {
    let { options, value, onChange, disabled } = this.props;

    let style = this.getStyle();
    return (
      <ErrorContainer style={style.input} id={this._componentId} {...this.props}>
        <RadioButtonGroup id={this._componentId}
                          name={this._componentId}
                          style={style.radioButtonGroup}
                          valueSelected={value}
                          onChange={onChange}>
          {options.map((option, index) => (
            <RadioButton key={index} disabled={disabled} {...option} style={style.radioButton}/>
          ))}
        </RadioButtonGroup>
      </ErrorContainer>
    );
  }
}

RadioGroup.defaultProps = {
  inline: false
};

export default RadioGroup;




// WEBPACK FOOTER //
// ./src/components/form/RadioGroup.jsx